import { Component, OnInit } from '@angular/core'
import { Auth, signOut, user, User } from '@angular/fire/auth'
import { NavigationEnd, Router } from '@angular/router'
import { Observable } from 'rxjs'
import { filter } from 'rxjs/operators'

@Component({
    selector: 'app-navmenu',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.scss'],
    standalone: false
})
export class NavComponent implements OnInit {
  private user$: Observable<User>

  constructor(private auth: Auth, private router: Router) {
    this.user$ = user(this.auth)
  }

  currentUserName = ''
  sideNavOpen = false
  showBackToList = false

  ngOnInit(): void {
    this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe((e: NavigationEnd) => {
      this.showBackToList = e.url !== '/active-dogs'
    })
    this.user$.subscribe((u) => {
      this.currentUserName = u?.email
      this.sideNavOpen = true
    })
  }

  async logout() {
    if (confirm('Biztos ki szeretnél jelentkezni?')) {
      await signOut(this.auth)
      this.router.navigate(['/login'])
    }
  }
}
